"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = __importDefault(require("axios"));
var config_1 = __importDefault(require("../config"));
/*
  This client authenticates with the Listen360 API using session-cookie authentication. This authentication is exactly
  what Rails uses for its standard authentication. In addition, just like Rails, we will also use a CSRF token in order
  to prevent cross-site request forgery.

  This client must have 4 things in order to authenticate with the Listen360 API:
  1) Be used in a browser
  2) Be used within the same domain as the API, a different sub-domain is valid
    (e.g. sparta.listen360.com can make calls to the Listen360 API hosted at app2.listen360.com -
    the app login would occur at app.listen360.com so the session cookie is valid for all of *.listen360.com)
  3) A valid session cookie is set in the browser
  4) A valid CSRF cookie is set in the browser

  Because of requirement #1 and #2 above, the session cookie will automatically be sent along in all requests by the
  browser. This will allow us to authentication for all GET requests.

  In order to authenticate for all PUT, POST, and DELETE requests, we also need to send across the CSRF token in the
  header.

  The 3 defaults set below will tell axios to add the CSRF token to the header of each request.
 */
var axiosConfig = {
    baseURL: config_1.default.apiBaseUrl,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
        Accept: 'application/json'
    },
    xsrfCookieName: process.env.NODE_ENV.toUpperCase() + "-CSRF-TOKEN",
    xsrfHeaderName: 'X-CSRF-Token',
    withCredentials: true
};
var instance = axios_1.default.create(axiosConfig);
instance.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error && error.response && error.response.status === 401 && window && window.location) {
        var returnTo = window.location.href;
        window.location.href = config_1.default.applicationBaseUrl + "/users/sign_in?return_to=" + returnTo;
        return;
    }
    return Promise.reject(error);
});
exports.default = instance;
//# sourceMappingURL=api_base.js.map